import HowToCreatePostModal from './HowToCreatePostModal';

export default HowToCreatePostModal;
